// firmennameVergleich.ts — ist das dieselbe Firma, nur anders geschrieben?
//
// T-333 (Dirk 15.10.2026): Die Signaturanlage legte „PLANPROTECT AG" neu an,
// obwohl „Planprotect AG" längst im Bestand stand — die Firma wurde nur über
// die E-Mail-Domain gesucht, nicht über ihren Namen. Verglichen wird deshalb
// der Name, und zwar so, wie ein Mensch ihn liest: Groß/Klein, Umlaute,
// Satzzeichen und die Schreibweise der Rechtsform („AG" ↔
// „Aktiengesellschaft", „GmbH & Co. KG" ↔ „GmbH & Co.KG") zählen nicht.
//
// Bewusst STRENG: Eine andere Rechtsform ist ein anderer Rechtsträger, und
// ein nur ähnlicher Name („… Service AG") ist kein Beleg. Wer mehr will, hat
// mit `namensNaehe` (visitenkarteFirmensuche.ts) die unscharfe Variante — die
// zeigt Treffer zur Auswahl, diese hier belegt ein Feld vor.

import { erkenneRechtsform } from "@kmvs/forms-core";
import { firmenKern } from "./visitenkarteFirmensuche";

/** Der Name ohne die Rechtsform am Ende („Muster GmbH & Co. KG" → „Muster"). */
export const ohneRechtsform = (name: string): string => {
  const wert = name.trim().replace(/\s+/g, " ");
  const befund = erkenneRechtsform(wert);
  if (befund.anker !== "SUFFIX" || !befund.fundstelle) return wert;
  const stelle = wert.toLowerCase().lastIndexOf(befund.fundstelle.toLowerCase());
  return stelle >= 0 ? wert.slice(0, stelle) : wert;
};

/** Rechtsform-Schlüssel, sofern der Name sie trägt (sonst null). */
const rechtsformVon = (name: string): string | null => {
  const befund = erkenneRechtsform(name.trim().replace(/\s+/g, " "));
  return befund.anker === "SUFFIX" ? befund.key : null;
};

/**
 * Zwei Firmennamen bezeichnen dieselbe Firma: gleicher Namenskern, und die
 * Rechtsformen widersprechen sich nicht. Fehlt sie auf einer Seite (die
 * Signatur schreibt oft nur „Planprotect"), entscheidet der Name allein.
 */
export function gleicherFirmenname(a: string, b: string): boolean {
  const kernA = firmenKern(ohneRechtsform(a ?? ""));
  const kernB = firmenKern(ohneRechtsform(b ?? ""));
  if (!kernA || kernA !== kernB) return false;
  const formA = rechtsformVon(a ?? "");
  const formB = rechtsformVon(b ?? "");
  return !formA || !formB || formA === formB;
}
